import * as React from "react";
import { useEffect, useState, useCallback } from "react";
import withParams from "routing/withParams";
import { DocumentTitle, PageHeader } from "components/common";
import UsersPageNavigation from "components/users/navigation/UsersPageNavigation";
import DocsHelper from "util/DocsHelper";
import { TeamsActions } from "../stores/TeamsStore";
import TeamsDomain from "../domainActions/TeamsDomain";
import TeamEdit from "../components/team-edit/TeamEdit";
import TeamActionLinks from "../components/navigation/TeamActionLinks";
const PageTitle = ({ name }) => /* @__PURE__ */ React.createElement(React.Fragment, null, "Team Edit", " ", name && /* @__PURE__ */ React.createElement(React.Fragment, null, "- ", /* @__PURE__ */ React.createElement("i", null, name)));
const TeamEditPage = ({ params }) => {
  const teamId = params == null ? void 0 : params.teamId;
  const [team, setTeam] = useState();
  const name = team == null ? void 0 : team.name;
  const fetchTeam = useCallback(() => TeamsDomain.load(teamId).then(setTeam), [teamId]);
  useEffect(() => {
    fetchTeam();
  }, [teamId, fetchTeam]);
  useEffect(() => TeamsActions.update.completed.listen(fetchTeam), [teamId, fetchTeam]);
  useEffect(() => TeamsActions.addMembers.completed.listen(fetchTeam), [teamId, fetchTeam]);
  useEffect(() => TeamsActions.removeMember.completed.listen(fetchTeam), [teamId, fetchTeam]);
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: `Team Edit ${name != null ? name : ""}` }, /* @__PURE__ */ React.createElement(UsersPageNavigation, null), /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: /* @__PURE__ */ React.createElement(PageTitle, { name }),
      actions: /* @__PURE__ */ React.createElement(TeamActionLinks, { team }),
      documentationLink: {
        title: "Permissions documentation",
        path: DocsHelper.PAGES.USERS_ROLES
      }
    },
    /* @__PURE__ */ React.createElement("span", null, "Edit settings and assign users and roles for this team.")
  ), /* @__PURE__ */ React.createElement(TeamEdit, { team }));
};
export default withParams(TeamEditPage);
